export function rawGET(url, headers) {
  return XHR('GET', url, headers);
}

export function GET(url, headers) {
  return rawGET(url, headers).then(getResponseData);
}

export function POST(url, headers, payload) {
  return XHR('POST', url, headers, payload).then(getResponseData);
}

export function XHR(method, url, headers = [], payload = undefined) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    headers.forEach(([header, value]) => xhr.setRequestHeader(header, value));
    xhr.withCredentials = false;
    xhr.onload = resolve;
    xhr.onerror = reject;
    xhr.send(payload);
  }).then(onRequestSuccess, onRequestFailure);
}

function onRequestSuccess(ev) {
  const { target: req } = ev;

  if (req.status >= 400) {
    throw new Error(req.response);
  }

  return req;
}

function onRequestFailure(_event) {
  throw new Error('Request failure');
}

export function getResponseData(req) {
  const response = JSON.parse(req.response);

  if (response.result !== 'ok') {
    throw new Error('Invalid request: ' + response.message);
  }

  return response.data;
}
